import React from "react";
import api from "../../../services/api";
import { Prefix } from "../../../services/prefix";
import { mutate as GlobalMutate } from "swr";

export default function UpdateStatus({
  id,
  page,
  perPage,
  activeDefault,
  search,
  orderBy,
  order,
}) {
  let pageExact = page + parseInt(1);
  let valueSearch = !search ? "" : search;

  function HandleStatus() {
    api
      .put(Prefix.replace(/[\\"]/g, "") + "/modules/" + id, {
        active: activeDefault === 1 || activeDefault === true ? 0 : 1,
      })
      .then(() => {
        GlobalMutate(
          Prefix.replace(/[\\"]/g, "") +
            "/modules?per_page=" +
            perPage +
            "&page=" +
            pageExact +
            "&search=" +
            valueSearch +
            "&order_by=" +
            orderBy +
            "&order=" +
            order
        );
      });
  }

  return (
    <>
      <label class="switch d-flex justify-content-center">
        <input
          type="checkbox"
          id={id + "modules"}
          onChange={HandleStatus}
          checked={activeDefault == 1 || activeDefault == true ? true : false}
        />
        <span class="slider round"></span>
      </label>
    </>
  );
}
